import React from "react";
import { RouteComponentProps } from 'react-router-dom';
import { connect } from "react-redux";
import Header from "../components/Header";
import { IQuoteStepState, IQuoteStepComponentProps } from "../components/interfaces";
import Utilities from "../classes/Utilities";
import { IAppState } from "../state/interfaces";
import { IVehicle, IViolationList, ICoverageConfig, IQuoteApiClient, ILOBApiClient, IPaths } from "../classes/Domain";
import QuoteActions from "../state/appActions";
import FullQuoteActions from "../state/fullQuoteActions";
import BravoApiClient from '../classes/BravoApiClient';
import ReactLoading from 'react-loading';
import queryString from 'query-string';

interface IState extends IQuoteStepState {
    quoteUid: string
}

export interface IProps extends RouteComponentProps {
    tkn: string,
    quoteUid: string,
    vehicles: Array<IVehicle>,
    createExternalQuote: (tkn: string) => Promise<any>,
    fillQuote: (quoteUid: string) => Promise<any>,
    fillExternalQuote: (update: any) => Promise<any>,
    updateViolationList: (update: any) => Promise<any>,
    selectCoverageConfig: (coverageConfig: ICoverageConfig) => Promise<any>,
    quoteApiClient: IQuoteApiClient,
    lobApiClient: ILOBApiClient,
    PATHS: IPaths,
    stateCode: string | null;
}

class BuyNowLandingQuote extends React.Component<IProps, IState>
{
    constructor(props: IProps) {
        super(props);

        this.state = {
            quoteUid: "",
            updatingStore: false
        };
    }

    componentDidMount() {
        this.setState({ updatingStore: true }, () => {
            this.props.createExternalQuote(this.props.tkn).then((result) => {
                this.props.fillQuote(result.data)
                    .then((result) => {
                        return result;
                    }, () => { this.setState({ ...this.state, updatingStore: false }); })
                    .then((result) => {
                        const rtrQuoteId = parseInt(result.data?.rtrQuoteId, 10);
                        if (rtrQuoteId) {
                            const fqApiClient = new BravoApiClient(result.data.stateCode);
                            fqApiClient.getQuote(rtrQuoteId)
                                .then((fqResponse) => {
                                    fqResponse.data.rtrQuoteId = rtrQuoteId;
                                    fqResponse.data.drivers?.forEach(x => x.birthDate = "")
                                    this.props.fillExternalQuote({ quote: fqResponse.data })
                                        .then(() => {
                                            fqApiClient.getViolationList(result.data.stateCode)
                                                .then((violResponse) => {
                                                    this.props.updateViolationList(violResponse.data)
                                                        .then(() => {
                                                            this.props.quoteApiClient.getCoverageConfigs(this.props.quoteUid)
                                                                .then((covResponse) => {
                                                                    this.props.selectCoverageConfig(covResponse.data[0])
                                                                        .then(() => {
                                                                            // Phase 9: Qualitas happy-path ends at agent-will-call (not full-quote).
                                                                            this.props.history.push(this.props.PATHS.AGENT_WILL_CALL);
                                                                        }, () => { this.setState({ ...this.state, updatingStore: false }); })
                                                                }, () => { this.setState({ ...this.state, updatingStore: false }); });
                                                        }, () => { this.setState({ ...this.state, updatingStore: false }); });
                                                }, () => { this.setState({ ...this.state, updatingStore: false }); });
                                        }, () => { this.setState({ ...this.state, updatingStore: false }); });
                                }, () => { this.setState({ ...this.state, updatingStore: false }); });
                        }
                        else {
                            this.setState({ ...this.state, updatingStore: false });
                        }
                    }, () => { this.setState({ ...this.state, updatingStore: false }); });
            }, () => { this.setState({ ...this.state, updatingStore: false }); } )
        });
    }

    render() {
        return (
            this.state.updatingStore
            ?
            <div>
                <Header />
                <div className="quote-step-body">
                    <div className="quote-step-container" style={{ maxWidth: "100em", width: "100%" }}>
                        <div className="card qContainer" style={{ padding: "2%" }}>
                            <div className="card-body">
                                <div className="titleArea"><h5>QUOTE LOADING...</h5></div>
                                <div className={"w-100 loading-indicator"}>
                                    <ReactLoading type={"spin"} color={"#0096AE"} height={'40px'} width={'40px'} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            :
            <div>
                <Header />
                <div className="quote-step-body">
                    <div className="quote-step-container" style={{ maxWidth: "100em", width: "100%" }}>
                        <div className="card qContainer" style={{ padding: "2%" }}>
                            <div className="card-body">
                                <div className="titleArea"><h5>Sorry. Unable to load Quote Data.</h5></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

let mapProps = (state: IAppState, ownProps: IQuoteStepComponentProps) => {
    var searchParams = queryString.parse(ownProps.location.search);

    return {
        tkn: searchParams?.tkn,
        quoteUid: state.quoteUid,
        vehicles: state.vehicles,
        stateCode: state.stateCode
    };
};

let mapDispatch = (dispatch: any, ownProps: IProps) => {
    var quoteActions = new QuoteActions(ownProps.quoteApiClient);
    var fullQuoteActions = new FullQuoteActions(ownProps.lobApiClient);

    return {
        createExternalQuote: (tkn) => dispatch(fullQuoteActions.createExternalQuote(tkn)),
        fillQuote: (quoteUid) => dispatch(quoteActions.agentLandingQuote(quoteUid)),
        fillExternalQuote: (update) => dispatch(fullQuoteActions.fillExternalQuote(update.quote)),
        updateViolationList: (update: IViolationList) => dispatch(quoteActions.updateViolatioList(update)),
        selectCoverageConfig: (update: ICoverageConfig) => dispatch(quoteActions.selectCoverageConfig(update))
    };
};

export default connect(mapProps, mapDispatch)(BuyNowLandingQuote);